export default "__VITE_ASSET__DZXrDpV___"